import React from "react";
import { Link } from "react-router-dom";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import ProjectsData from "../../api/projects"; // renamed for clarity

interface ProjectItem {
  slug: string;
  title?: string;
  location?: string;
  date?: string;
  pimg1: string;
}

interface ProjectSectionProps {
  prClass?: string;
}

const ProjectSection: React.FC<ProjectSectionProps> = ({ prClass = "" }) => {
  const ClickHandler = (): void => {
    window.scrollTo({ top: 10, behavior: "smooth" });
  };

  const Projects: ProjectItem[] = ProjectsData as ProjectItem[];

  return (
    <section className={`wpo-portfolio-section-s4 ${prClass}`}>
      <div className="container-fluid">
        <div className="portfolio-wrapper">
          <div className="sortable-gallery">
            <div className="gallery-filters"></div>
            <div className="row">
              <div className="col-lg-12">
                <div className="portfolio-grids gallery-container clearfix">
                  <ResponsiveMasonry
                    columnsCountBreakPoints={{ 350: 1, 750: 1, 900: 3 }}
                  >
                    <Masonry gutter="60px">
                      {Projects.slice(0, 6).map(
                        (project: ProjectItem, index: number) => (
                          <div className="grid" key={index}>
                            {project.title ? (
                              <div className="img-holder">
                                <img
                                  src={project.pimg1}
                                  alt={project.title || "Project"}
                                />
                                <div className="portfolio-content">
                                  <h4>
                                    <Link
                                      onClick={ClickHandler}
                                      to={`/project-single/${project.slug}`}
                                    >
                                      {project.title}
                                    </Link>
                                  </h4>
                                  {project.location && project.date && (
                                    <span>
                                      {project.location} - {project.date}
                                    </span>
                                  )}
                                </div>
                              </div>
                            ) : (
                              <div className="img-holder">
                                <img src={project.pimg1} alt="Project" />
                              </div>
                            )}
                          </div>
                        )
                      )}
                    </Masonry>
                  </ResponsiveMasonry>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectSection;
